export default __webpack_public_path__ + "static/media/Gilroy-Medium.23dfbc19.ttf";